import { useContext } from "react";
import BasePhoneLink from "@/components/BaseComponents/BasePhoneLink";
import { CompanyContext } from "@/components/CompanyList/CompanyContext";
import { twMerge } from "@/helpers/twMerge";
import { getCompanyPhoneNumber } from "@/selectors";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";

import { PhoneIcon } from "../../../../thecreditreview/assets/icons/PhoneIcon";

export const PhoneLink = ({ className }) => {
	const { company } = useContext(CompanyContext);
	const phoneNumber = useSelector((state) =>
		getCompanyPhoneNumber(state, { company }),
	);

	return (
		<BasePhoneLink
			company={company}
			className={twMerge(
				`tw:relative tw:mb-4 tw:flex tw:h-[48px] tw:w-[175px] tw:items-center tw:justify-center tw:rounded-[3px] tw:bg-[#bee3f8] tw:py-3 tw:hover:bg-[#90cef4] tw:desktop:mb-4 tw:lg:flex tw:lg:w-full tw:lg:py-0`,
				className,
			)}
		>
			<div className="tw:flex tw:items-center tw:justify-center tw:rounded-full">
				<PhoneIcon className="tw:h-6 tw:w-6 tw:desktop:h-4 tw:desktop:w-4 tw:lg:h-5 tw:lg:w-5 tw:lg2:h-6 tw:lg2:w-6" />
			</div>
			<div className="tw:ml-2 tw:text-sm tw:leading-4 tw:font-semibold tw:text-white tw:desktop:ml-1 tw:desktop:text-xs tw:lg:ml-2 tw:lg2:text-sm">
				{phoneNumber}
			</div>
		</BasePhoneLink>
	);
};

PhoneLink.propTypes = {
	className: PropTypes.string,
};
